import { Component, Prop, Vue } from "vue-property-decorator";
import DashboardFilter from "../DashboardFilter/DashboardFilter.vue";
import { FilterOfCollection } from "../../models/FilterOfCollection";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { mapGetters } from "vuex";
import { SectionOfDashboard } from "../../models/SectionOfDashboard";
import { GENERAL_CONSTANTS } from "@/shared/constants/GeneralConstants";
import store from "@/store";
import { DASHBOARD_TEMPLATE_EVENTS } from "../../constants/DashboardTemplatesConstants";

@Component({
  name: "FiltersModal",
  components: { DashboardFilter },
  computed: {
    ...mapGetters({
      sectionsOfDashboardStore: "getSectionsOfdashboard"
    })
  }
})
export default class FiltersModal extends Vue {
  @Prop() indexSection!: number;
  @Prop() indexCollection!: number;
  @Prop() modalData!: {
    title: string;
  };

  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  addItem = GENERAL_CONSTANTS.ICONS.ADD;
  filters: FilterOfCollection[] = [];
  sectionsOfDashboardStore!: Array<SectionOfDashboard>;
  collectionData: any = [];
  collectionFields: any = {};
  reloadFilter = 0;

  mounted() {
    this.loadData();
  }

  loadData() {
    console.log(
      this.indexSection,
      this.indexCollection,
      this.sectionsOfDashboardStore[this.indexSection].collections[
        this.indexCollection
      ]
    );
    this.filters = this.sectionsOfDashboardStore[this.indexSection].collections[
      this.indexCollection
    ].filters;
    this.collectionData = this.sectionsOfDashboardStore[
      this.indexSection
    ].collections[this.indexCollection];
    this.collectionFields = this.collectionData.collection.find(
      (e: any) => e.id == this.collectionData.id
    );
  }

  addFilter() {
    store.commit(DASHBOARD_TEMPLATE_EVENTS.ADD_FILTER, {
      indexSectionOfDashboard: this.indexSection,
      index: this.indexCollection,
      onefilter: { field: [], operator: [], value: [] }
    });
    this.reloadFilter++;
  }

  saveFilter() {
    this.$emit(DASHBOARD_TEMPLATE_EVENTS.SAVE_FILTER);
  }

  cancelFilter() {
    this.$emit(DASHBOARD_TEMPLATE_EVENTS.CANCEL_FILTER);
  }
}
